module.exports = __webpack_public_path__ + "resources/images/subscription-851d207f5f4338f5aea035931c2688a6-cache.jpg";